
import { getSummary } from '../api/summary'
import type { Resolvers } from '../generated/resolvers'

const SummaryResolver: Resolvers = {
  Query: {
    summary: async (_, { id, include_calculated_values, include_source_response }) => {
      const response = await getSummary(id, 'case', include_calculated_values, include_source_response)
      return response
    },
  },

}

export default SummaryResolver